import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const duna: Collection = {
  id: 'ona-duna',
  brandId: 'ona',
  brandName: 'Ona',
  icon: 'ona.png',
  title: 'Duna',
  subTitle: 'Stijlvol',
  banner: 'duna/duna-banner.jpg',
  items: [
    {
      id: 'ona-duna-1',
      collectionImages: [
        {
          image: 'duna/Duna.jpg',
          width: CollectionBannerWidth['100%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'ona-duna-2',
      collectionImages: [
        {
          image: 'duna/Duna_blue_1.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'duna/Duna_blue_2.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'duna/Duna_blue.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    '8ac9fa71-7573-4aeb-83d2-a9494453036c',
    '17156eab-2bac-4df5-ac92-919c29c73745',
    '6871f17d-6964-48e9-a1a2-e5a9378ea6a9',
    'a69b52f2-a546-49a7-8395-d610cb216378',
    '82065264-8967-42c7-a798-8b292281da24',
    'c6efce21-91f5-4f39-bb6a-86ab68ab3980',
    '1a8486e6-18f4-45e9-9e64-8bfcd3ec6d5a',
    '233fb4d7-0e4f-4994-9812-e37af327bcde',
    '6a2fd8f7-85e6-4e7e-ad67-04fd3d53af5c',
    'f1bf92e5-2b54-4547-bc0e-cdf7d8c89dfe',
    '0c43f3ac-8bbf-4273-a96c-a05491504de3',
    '47c3eefd-514a-4720-a6ab-2bda94d4eaca',
    '426ba266-2bb1-4a1f-91cd-9c93ff6c57b8',
    '48685adf-ca84-49ca-ad55-0273a3fda7f6',
    'cef8488e-3ed5-483e-a136-4296e5d46d9c',
    '4660108a-8e8a-4237-8220-461046ba6c4d',
    'e271f24c-1916-468e-9e86-d87a17877705',
    '54cd30a4-2846-4398-8cad-9f44d126ad0b'
  ]
};
